import React, { FC } from "react";
import { Button, Link } from "@mui/material";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import RoutePaths from "routes/RoutePaths";
import { logo } from "assets/images";
import { useAuthSelectors } from "redux/selectors";
import "./styles.scss";

const Footer: FC = () => {
  const { push } = useHistory();
  const { t } = useTranslation();

  const { selectAuthUser } = useAuthSelectors();

  return (
    <div className="footer">
      <div className="col-area">
        <div className="col-single">
          <Link onClick={() => push(RoutePaths.root)}>
            <img src={logo} className="footer-logo" alt="" />
          </Link>
        </div>
        <div className="col-single">
          <Link onClick={() => push(RoutePaths.howToUseGuide)}>
            {t("footer.links.howToUse")}
          </Link>
          <Link onClick={() => push(RoutePaths.paymentPolicy)}>
            {t("footer.links.paymentPolicyPage")}
          </Link>
          <Link onClick={() => push(RoutePaths.InstructorPolicy)}>
            {t("footer.links.teacherPolicy")}
          </Link>
        </div>
        <div className="col-single">
          <Link onClick={() => push(RoutePaths.cancellationPolicy)}>
            {t("footer.links.cancelPolicy")}
          </Link>
          <Link onClick={() => push(RoutePaths.privacyPolicy)}>
            {t("footer.links.privacyPolicy")}
          </Link>
          {selectAuthUser && (
            <Link onClick={() => push(RoutePaths.contactForm)}>
              {t("footer.links.contactUs")}
            </Link>
          )}
        </div>
        <div className="col-single">
          <Link onClick={() => push(RoutePaths.termsOfService)}>
            {t("footer.links.termsOfService")}
          </Link>
          <Link onClick={() => push(RoutePaths.transactionLaw)}>{t("footer.links.transactionLaw")}</Link>
        </div>
        <div className="col-single">
          {(!selectAuthUser?.isExpert || !selectAuthUser?.isExpertApproved) && (
            <Button
              component="button"
              className="fill"
              onClick={() => {
                !selectAuthUser?.isExpert
                  ? push(RoutePaths.expertRegisterInfo)
                  : push(RoutePaths.expertHome);
              }}
            >
              {!selectAuthUser?.isExpert
                ? t("home.teacherRegistration")
                : t("home.teacherProfile")}
            </Button>
          )}
        </div>
      </div>
      <div className="footer-bottom">
        <div className="col-left">
          <Link>{t("footer.links.operatingCompany")}</Link>
          <a href="https://www.aacf.or.jp/" target="_blank" className="external">{t("footer.links.companyName")}</a>
        </div>
        <div className="col-right">{t("footer.links.copyright")}</div>
      </div>
    </div>
  );
};

export default Footer;
